//imports
import {
    DEALERS_OVERVIEW_GET_DATA_REQUEST,
    DEALERS_OVERVIEW_GET_DATA_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    dealer: null,
    error: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case DEALERS_OVERVIEW_GET_DATA_REQUEST:
            return { ...state, loading: true };
            
        case DEALERS_OVERVIEW_GET_DATA_RESULT:
            return { ...state, loading: false, dealer: action.payload.data, error: action.payload.error };

        case CLEAR_REDUX:
            return ["", "DEALER_OVERVIEW"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
